<div *ngIf="isBootstrapLayout; then bsLayout; else normalLayout"></div>

<ng-template #bsLayout>
  <div class="layout bs-parent" [class]="parentClasses">
    <ng-container *ngTemplateOutlet="layoutChildren"></ng-container>
  </div>
</ng-template>

<ng-template #normalLayout>
  <div class="layout" [class]="layoutClass">
    <ng-container *ngTemplateOutlet="layoutChildren"></ng-container>
  </div>
</ng-template>

<ng-template #layoutChildren>
  <ng-container *ngFor="let kids of childrenByRegion | keyvalue: originalOrder">
    <div
      *ngIf="isBootstrapLayout; else layoutChild"
      [class]="getCustomClasses(kids.key)"
    >
      <ng-container *ngTemplateOutlet="layoutChild"></ng-container>
    </div>
    <ng-template #layoutChild>
      <div [class]="kids.key" class="region-child">
        <ng-container *ngFor="let child of kids.value">
          <digital-platform-dynamic-content-wrapper
            [config]="child"
          ></digital-platform-dynamic-content-wrapper>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>
</ng-template>
